import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { HousingOptions } from 'src/shared/constants/housingOptions';
import { InterestOptions } from 'src/shared/constants/interestOptions';

@Component({
  selector: 'app-createuser',
  templateUrl: './createuser.component.html',
  styleUrls: ['./createuser.component.css', '../../shared/styles/formStyles.css']
})
export class CreateuserComponent {
  name: string | undefined;
  bio: string | undefined;
  interests: string[] | undefined;
  housing: string | undefined;

  housingOptions: { [key: string]: string } = HousingOptions;
  housingKeys: string[] = Object.keys(this.housingOptions);

  interestOptions: { [key: string]: string } = InterestOptions;
  interestKeys: string[] = Object.keys(this.interestOptions);

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  onCheckChange(event: Event, key: string) {
    if (!event.target) return;

    this.interests = this.interests ?? [];

    if ((event.target as HTMLInputElement).checked) {
      this.interests.push(key);
    } else {
      const index = this.interests.indexOf(key, 0) ?? -1;
      if (index > -1) {
        this.interests.splice(index, 1);
      }
    }
  }

  submit(): void {

    const name = this.name ?? "";
    const bio = this.bio ?? "";
    const interests = this.interests ?? [];
    const housing = this.housing ?? "";

    this.userService.addUserInfo(name, bio, interests, housing);

    console.log(interests);

    this.router.navigate(['/homepage']);
  }

  goToOrg(): void {
    this.router.navigate(['/createorg']);
  }
}
